import client from './client';

export default {
  fetch() {
    return client.get('/payments/invoices/index')
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/transactionsAPI.js